import React from 'react';
import { Box } from '@material-ui/core';
import { Theme } from '@orijinworks/frontend-commons';
import DeleteModal from '../../../../../../shared/components/DeleteModal/DeleteModal';
import AddWidgetModal from '../../../../components/add-widget-modal';
import EditorsPlanModal from '../../../../components/editors-plan-modal';
import ExportPlanModal from '../../../../components/export-plan-modal';
import { CasePlanDetailHeader } from '../CasePlanDetailHeader';
import { CasePlanDetailsSections } from '../CasePlanDetailsSections';
import { MoveWidgetToSectionModal } from '../MoveWidgetToSectionModal';

const resolveOpenConfirmation = (sectionConfirmation, widgetConfirmation) =>
  [sectionConfirmation, widgetConfirmation].find((confirmation) => confirmation?.isOpen);

export function CasePlanDetailsContent({
  classes,
  cardProps,
  isViewOnly = false,
  isSectionsLoading,
  collapsedSections,
  onBack,
  onToggleCollapse,
  onAddWidget,
  isAddWidgetOpen = false,
  widgetTypeCategories = [],
  onAddWidgetClose,
  onAddWidgetSelect,
  onWidgetDescriptionBlur,
  onEditorsClick,
  canManageEditors = false,
  isEditorsOpen,
  onEditorsClose,
  onEditorsSaved,
  planId,
  onExportClick,
  isExportOpen,
  onExportClose,
  onExportSubmit,
  status,
  isEditor,
  onStatusSelect,
  pendingStatus,
  onStatusConfirm,
  onStatusCancel,
  sectionApi = {},
  widgetApi = {},
}) {
  const { activeSections = [], sectionConfirmation } = sectionApi;
  const {
    moveToSectionModal = {},
    onConfirmMoveToSection,
    onCloseMoveToSectionModal,
    widgetConfirmation,
  } = widgetApi;
  const openConfirmation = resolveOpenConfirmation(
    sectionConfirmation,
    widgetConfirmation,
  );

  return (
    <Theme>
      <Box className={classes.page} role="main" aria-label="Case Plan Details">
        <CasePlanDetailHeader
          cardProps={cardProps}
          isSectionsLoading={isSectionsLoading}
          onBack={onBack}
          onEditorsClick={canManageEditors ? onEditorsClick : undefined}
          onExportClick={onExportClick}
          status={status}
          isEditor={isEditor}
          isViewOnly={isViewOnly}
          onStatusSelect={onStatusSelect}
          pendingStatus={pendingStatus}
          onStatusConfirm={onStatusConfirm}
          onStatusCancel={onStatusCancel}
        />
        <CasePlanDetailsSections
          isSectionsLoading={isSectionsLoading}
          collapsedSections={collapsedSections}
          onToggleCollapse={onToggleCollapse}
          onAddWidget={onAddWidget}
          onWidgetDescriptionBlur={isViewOnly ? undefined : onWidgetDescriptionBlur}
          sectionApi={sectionApi}
          widgetApi={isViewOnly ? undefined : widgetApi}
        />
        {/* Archived sections are excluded: an export must only carry the live plan. */}
        <EditorsPlanModal
          open={isEditorsOpen}
          planId={planId}
          onClose={onEditorsClose}
          onSaved={onEditorsSaved}
        />
        <ExportPlanModal
          open={isExportOpen}
          sections={activeSections}
          onClose={onExportClose}
          onExport={onExportSubmit}
        />
        <AddWidgetModal
          open={isAddWidgetOpen}
          categories={widgetTypeCategories}
          onClose={onAddWidgetClose}
          onSelect={onAddWidgetSelect}
        />
        {openConfirmation && (
          <DeleteModal
            open
            status={openConfirmation.modalStatus}
            title={openConfirmation.title}
            description={openConfirmation.description}
            onClose={openConfirmation.onCancel}
            onContinue={openConfirmation.onConfirm}
          />
        )}
        <MoveWidgetToSectionModal
          open={moveToSectionModal.isOpen}
          destinations={moveToSectionModal.destinations}
          onSelect={onConfirmMoveToSection}
          onClose={onCloseMoveToSectionModal}
        />
      </Box>
    </Theme>
  );
}
